import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactSelect from 'react-select';

import debounce from 'lodash.debounce';
import TextInput from '~/Components/Global/Form/TextInput';
import RecoveryModeToggle from '~/Components/Pages/Lists/RecoveryModeToggle.js';

import Edit from '~/Components/Global/Assets/Svgs/Edit';
import New from '~/Components/Global/Assets/Svgs/New';
import Trash from '~/Components/Global/Assets/Svgs/Trash';
import FeatureFlagView from '~/Components/Global/FeatureFlagView';
import { FLAG_LIST_RECOVERY, FLAG_LIST_FOLDERS } from '~/Redux/Modules/FeatureFlags';

import './Toolbar.scss';
import ListsDropDown from './ListsDropDown/ListsDropDown';
import DropDownMenu from './ListsDropDown/DropDownMenu';
import FolderContents from './ListsDropDown/FolderContents';
import FolderModal from './ListsDropDown/FolderModal';

class Toolbar extends Component {
  constructor() {
    super();
    this.state = {
      newList: '',
      moreIcons: true,
      createNew: false,
      defaultListName: 'My New List',
      editListTitle: false,
      listsDropDownOpen: false,
      activeFolderId: null,
      activeFolderIsActive: false,
      showSubMenu: false,
      showModal: false,
      listToMove: null,
      subMenuTop: 0,
    };
  }

  generateColorOptions = () => {
    return this.props.colors.map((color, index) => {
      return <option key={index} value={color} label={color} />;
    });
  };

  handleChangeListName = e => {
    this.setState({ newList: e.newList });
  };

  toggleMoreIcons = () => {
    this.setState({ moreIcons: !this.state.moreIcons });
  };

  toggleCreate = () => {
    const { userLists, parentCreate, setCurrent } = this.props;
    if (!this.state.createNew) {
      parentCreate();
      this.setState({ createNew: true, newList: '' }, () => {
        setCurrent({ title: '', body: '' });
        if (this.state.listsDropDownOpen) {
          this.handleListDropDownClick();
        }
      });
      this.saveList();
    } else {
      setCurrent(userLists[0]);
      this.setState({ createNew: false });
    }
  };

  saveList = debounce(() => {
    const { quill, createList } = this.props;
    const { defaultListName, newList } = this.state;
    createList({
      body: quill.container.querySelector('.ql-editor').innerHTML || '',
      title: newList || defaultListName,
    });
    this.setState({ ...this.state, createNew: false });
  }, 10);

  deleteList = () => {
    const { current, userLists, setCurrent, deleteList } = this.props;
    if (current && window.confirm(`Are you sure you want to delete ${current.title}?`)) {
      if (current.id === userLists[0].id) {
        if (userLists[1]) {
          setCurrent(userLists[1]);
          return deleteList(current);
        }
        deleteList(current);
        this.setState({ ...this.state, newList: '' });
        if (this.state.listsDropDownOpen)
          this.setState({ ...this.state, listsDropDownOpen: false });
        return;
      }
      setCurrent(userLists[0]);
      return deleteList(current);
    }
  };

  handleKeyDown = e => {
    if (e.keyCode === 13) {
      this.saveList();
      this.props.handleFocus();
    }
  };

  startEditListName = title => {
    this.setState({ ...this.state, editListTitle: title });
  };

  finishEditListName = () => {
    const { saveTitle } = this.props;
    const { editListTitle } = this.state;
    if (editListTitle) saveTitle(editListTitle);
    this.setState({ ...this.state, editListTitle: false });
  };

  handleEditListName = event => {
    const { editList } = event;
    this.setState({ ...this.state, editListTitle: editList });
  };

  handleEditKeyDown = e => {
    e.stopPropagation();
    if (e.keyCode === 13) {
      e.preventDefault();
      this.finishEditListName();
      this.props.handleFocus();
    }
  };

  handleListDropDownClick = () => {
    this.state.listsDropDownOpen === true
      ? this.setState({ ...this.state, listsDropDownOpen: false })
      : this.setState({ ...this.state, listsDropDownOpen: true });
    if (this.state.showSubMenu) {
      this.handleShowSubMenu(false, null);
    }
  };

  handleChangeActiveFolder = folderId => {
    this.setState({ activeFolderId: folderId });
  };

  handleActiveFolderisActive = bool => {
    this.setState({ activeFolderIsActive: bool });
  };

  handleShowSubMenu = (bool, folderId) => {
    const { current } = this.props;
    this.setState({ showSubMenu: bool }, () => {
      if (this.state.showSubMenu) {
        const clickedFolder = document.getElementById(folderId);
        const clickedFolderBottom = clickedFolder.getBoundingClientRect().bottom + window.scrollY;
        const listTitle = document.getElementById(current.id);
        const listTitleTop = listTitle.getBoundingClientRect().top;
        const primaryDropDown = document.getElementById('lists-dropdown-menu');
        const primaryDropdownBottom = primaryDropDown.getBoundingClientRect().height + 60;
        const subMenu = document.getElementById(`active-folder-${folderId}`);
        const subMenuHeight = subMenu.getBoundingClientRect().height;
        const maxSubMenuHeight = window.innerHeight * 0.92; //93vh in CSS
        let topPosition = clickedFolderBottom - listTitleTop; //default topPosition for subMenu
        const bottomSubMenuPosition = topPosition + subMenuHeight;
        if (subMenuHeight >= maxSubMenuHeight) {
          topPosition = 85; //should sit 25 lower than primary top (currently at 60)
        } else if (
          bottomSubMenuPosition > primaryDropdownBottom &&
          primaryDropdownBottom - subMenuHeight - 25 > 0
        ) {
          topPosition = primaryDropdownBottom - subMenuHeight - 25; //25 is the difference between 60, the static top position of primary and 85, the static topPosition for subMenu
        }
        this.setState({ subMenuTop: topPosition });
      }
    });
  };

  handleModal = id => {
    const { userLists } = this.props;
    const selectedList = userLists.find(list => list.id === id);
    this.setState({ listToMove: selectedList });
    if (!this.state.showModal) {
      this.setState({ showModal: true });
      if (this.state.showSubMenu) {
        this.setState({ showSubMenu: false });
      }
    }
  };

  setShowModal = bool => {
    this.setState({ showModal: bool });
  };

  sortOptions = [
    'Date last modified',
    'Newest to oldest',
    'Oldest to newest',
    'Title A - Z',
    'Title Z - A',
  ];

  renderValue = value => {
    return (
      <TextInput
        name="editList"
        className="minimal-input"
        value={this.state.editListTitle === false ? value.title : this.state.editListTitle}
        formGroup={false}
        onFocus={() => this.startEditListName(value.title)}
        onBlur={this.finishEditListName}
        onChange={this.handleEditListName}
        onKeyDown={this.handleEditKeyDown}
        isDisabled={this.props.inRecoveryMode}
      />
    );
  };

  render() {
    const { userLists, current, onChangeList, fetched, userFolders } = this.props;
    const { moreIcons, newList, createNew, listsDropDownOpen } = this.state;
    return (
      <div id="toolbar">
        <div className="flex-row top-row">
          <div className="list-select">
            {current && userLists.length && !createNew ? (
              <FeatureFlagView
                featureName={FLAG_LIST_FOLDERS}
                disabledView={
                  <ReactSelect
                    name="lists"
                    options={userLists}
                    className="minimal-input"
                    valueKey="id"
                    labelKey="title"
                    onChange={onChangeList}
                    value={current.id}
                    clearable={false}
                    valueRenderer={this.renderValue}
                    searchable={false}
                    backSpaceRemoves={false}
                    onInputKeyDown={() => console.log('onInputKeyDown')}
                  />
                }
              >
                <ListsDropDown
                  listsDropDownOpen={listsDropDownOpen}
                  handleListDropDownClick={this.handleListDropDownClick}
                  userLists={userLists}
                  valueRenderer={this.renderValue}
                  current={current}
                />
              </FeatureFlagView>
            ) : (
              <TextInput
                name="newList"
                placeholder="My New List"
                className="minimal-input"
                value={newList}
                onChange={this.handleChangeListName}
                onKeyDown={this.handleKeyDown}
                onBlur={this.saveList}
                disabled={!fetched}
                formGroup={false}
              />
            )}
          </div>
          <div className="right-icons">
            <button onClick={this.deleteList} className="quill-button">
              <Trash />
            </button>
            <button
              onClick={this.toggleMoreIcons}
              className={moreIcons ? `active quill-button` : `quill-button`}
            >
              <Edit />
            </button>
            <button
              onClick={this.toggleCreate}
              className={createNew ? `active quill-button` : `quill-button`}
            >
              <New />
            </button>
            <button className="ql-list" value="check" title="Checklist" />
            <button className="ql-header" value="2" />
            <FeatureFlagView featureName={FLAG_LIST_RECOVERY}>
              <RecoveryModeToggle />
            </FeatureFlagView>
          </div>
        </div>
        <div className={moreIcons ? `bottom-row active clear-fix` : `bottom-row clear-fix`}>
          <div className="close-btn" onClick={this.toggleMoreIcons}>
            x
          </div>
          <div className="button-row">
            <button className="ql-bold" />
            <button className="ql-italic" />
            <button className="ql-underline" />
            <button className="ql-strike" />
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
          </div>
          <div className="button-row">
            <select className="ql-size" defaultValue="" title="Text Size">
              <option value="small" />
              <option />
              <option value="large" />
              <option value="huge" />
            </select>
            <select className="ql-color ql-picker-right" defaultValue="black" title="Text Color">
              {this.generateColorOptions()}
            </select>
            <select
              className="ql-background ql-picker-right"
              defaultValue="white"
              title="Highlight Color"
            >
              {this.generateColorOptions()}
            </select>
          </div>
          <div className="button-row">
            <button className="ql-align" />
            <button className="ql-align" value="center" />
            <button className="ql-align" value="right" />
            <button className="ql-align" value="justify" />
          </div>
        </div>
        {listsDropDownOpen && (
          <DropDownMenu
            toggleCreateList={this.toggleCreate}
            handleListDropDownClick={this.handleListDropDownClick}
            current={this.props.current}
            userLists={userLists}
            onChangeList={onChangeList}
            userFolders={userFolders}
            sortOptions={this.sortOptions}
            activeFolderId={this.state.activeFolderId}
            handleChangeActiveFolder={this.handleChangeActiveFolder}
            handleActiveFolderIsActive={this.handleActiveFolderisActive}
            showSubMenu={this.state.showSubMenu}
            handleShowSubMenu={this.handleShowSubMenu}
            handleModal={this.handleModal}
          />
        )}
        {this.state.showSubMenu && this.state.activeFolderIsActive && (
          <FolderContents
            handleListDropDownClick={this.handleListDropDownClick}
            sortOptions={this.sortOptions}
            activeFolderId={this.state.activeFolderId}
            lists={userLists}
            showSubMenu={this.state.showSubMenu}
            handleShowSubMenu={this.handleShowSubMenu}
            current={this.props.current}
            onChangeList={onChangeList}
            handleModal={this.handleModal}
            setShowModal={this.setShowModal}
            subMenuTop={this.state.subMenuTop}
          />
        )}
        {this.state.showModal && (
          <FolderModal
            setShowModal={this.setShowModal}
            listToMove={this.state.listToMove}
            userFolders={userFolders}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = ({ UserLists: { lists } }) => {
  return {
    inRecoveryMode: lists.inRecoveryMode,
  };
};
const mapDispatchToProps = () => {
  return {};
};
Toolbar.propTypes = {
  onChangeList: propTypes.func,
  parentCreate: propTypes.func,
  unsetCurrent: propTypes.func,
  createList: propTypes.func,
  deleteList: propTypes.func,
  setCurrent: propTypes.func,
  userLists: propTypes.array,
  userFolders: propTypes.array,
  fetched: propTypes.bool,
  quill: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  current: propTypes.oneOfType([propTypes.object, propTypes.bool]),
  handleFocus: propTypes.func,
  saveTitle: propTypes.func,
  inRecoveryMode: propTypes.bool,
  colors: propTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
